import React from "react";
import styled from "styled-components";

const OptionIconGroup = styled.div`
    display: inline-flex;
    justify-content: center;
    vertical-align: middle;
    margin-right: 10px;
    margin-left: 17px;
`;

const OptionIcon = styled.img`
    height: 40px;
    margin-left: ${p => p.$isFirst ? "0" : "-4px"};
`;

export const SurveySelectOptionContent = (option) => (
    <>
        {option?.label}
        {(option?.icons || option?.icon) && (
            <OptionIconGroup>
                {option?.icons ? (
                    option.icons.map((icon, index) => (
                        <OptionIcon
                            key={`${option.value}_icon_${index}`}
                            src={icon}
                            $isFirst={index === 0}
                            alt={option.label}
                        />
                    ))
                ) : (
                    <OptionIcon
                        src={option.icon}
                        $isFirst
                        alt={option.label}
                    />
                )}
                {option?.icon && (option?.value === "Rating" || option?.value === "Satisfaction") && (
                    <>
                        <OptionIcon src={option.icon} alt={option.label} />
                        <OptionIcon src={option.icon} alt={option.label} />
                        <OptionIcon src={option.icon} alt={option.label} />
                        <OptionIcon src={option.icon} alt={option.label} />
                    </>
                )}
            </OptionIconGroup>
        )}
    </>
);
